import * as React from 'react';
import {runTokenIntents} from '../token';
import {hasOwnProperty} from '../util';
import {Priority} from './constants';
import {runElementTransforms} from './element';
import {addIntentsToRevision} from './ViewRevision';
import type {View} from './types';
import {runLazyStyleIntents} from '../style/StyleIntent';
import type {CssPolicy} from '../providers/EngineConfigProvider';

// React 19 renders boolean `inert`; React 18 only renders string values.
const rendersBooleanInert = parseInt(React.version, 10) >= 19;

export function normalizeInertProp(
  props: {inert?: unknown},
  booleanInert = rendersBooleanInert,
): void {
  if (!hasOwnProperty(props, 'inert')) {
    return;
  }

  const inert = props.inert === true || props.inert === '';
  if (booleanInert) {
    props.inert = inert;
  } else if (inert) {
    props.inert = '';
  } else {
    delete props.inert;
  }
}

export function runDomIntents<
  Props,
  Options extends View.ConfigOptions = never,
>(
  revision: View.ViewRevision<Props>,
  options: Options,
  cssPolicy?: CssPolicy,
): void {
  addIntentsToRevision(
    revision,
    runTokenIntents(revision, cssPolicy),
    Priority.Normal,
  );

  runElementTransforms(revision);
  runLazyStyleIntents(revision, options, cssPolicy);
  normalizeInertProp(revision.props as {inert?: unknown});
}
